<template>
  <div style="background:#292929;">
    <Nav ref="nava"></Nav>
    <div style="width: 100%;height: calc(100vh - (100px + 8vh));box-sizing: border-box;padding-top:20px;">
      <div style="background: #191919;margin: 0 auto;width:1200px;height:95%;box-sizing: border-box;padding-top:70px;">
        <div style="width: 304px;margin:0 auto;height:200px;">
          <div style="height:68px;width:228px;margin:0 auto;">
            <img src="https://oss.ansongqiubo.com/Image/qqMobile/bangding.png" alt="">
          </div>
          <div style="width:100%;text-align: center;font-size:20px;color:#fff;margin-top:20px;">
            绑定手机号
          </div>
          <div style="display:flex;width:304px;height:40px;margin:0 auto;border-radius: 4px;margin-top:20px;">
            <input v-model="mobile" type="text"
              style="width: 304px;height: 40px;background: #464646;border-radius: 4px;border:0;outline: none;box-sizing: border-box;padding-left: 20px;color:#fff;"
              placeholder="请输入手机号" maxlength="11" onkeyup="this.value=this.value.replace(/\D/g,'')">
          </div>
          <div style="color:red;font-size:14px;">{{ hint }}</div>
          <div style="display:flex;width:304px;height:40px;margin:0 auto;border-radius: 4px;margin-top:15px;">
            <input v-model="token" type="text"
              style="width: 304px;height: 40px;background: #464646;border-radius: 4px 0 0 4px;border:0;outline: none;box-sizing: border-box;padding-left: 20px;color:#fff;"
              placeholder="请输入验证码">
            <div v-show="botton1" @click="acquiretoken"
              style="width:calc(304px - 106px);height:40px;background:#721EDC;border-radius: 0px 4px 4px 0px;text-align: center;line-height: 40px;color:#fff;cursor:pointer;">
              获取验证码</div>
            <div v-show="botton2"
              style="width:calc(304px - 106px);height:40px;background:#D4B2FF;border-radius: 0px 4px 4px 0px;text-align: center;line-height: 40px;color:#fff;cursor:pointer;">
              {{ btnTitle }}</div>

          </div>
          <button class="home-longin-botton3" :disabled="!tongyi" :class="{ denglubutton: tongyi }"
            @click="Login">授权并登录</button>
          <div class="home-longin-div6">
            <input style="width: 15px;height:15px;" type="checkbox" v-model="tongyi">
            <span>我已阅读并同意</span>
            <a href="http://h5.ansongqiubo.com/h5/userregegistry.html" target="_Blank">《用户注册协议》</a>
            <a href="http://h5.ansongqiubo.com/h5/privatepolicy.html" target="_Blank">《隐私政策》</a>
            <a href="http://h5.ansongqiubo.com/h5/longzhulive.html" target="_Blank">《儿童/青少年个人信息保护规则》</a>
            <a href="http://h5.ansongqiubo.com/h5/chinamobile.html" target="_Blank">《中国移动认证服务条款》</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部网管 -->
    <div style="width:100%;height:100px;background:black;box-sizing: border-box;padding: 20px 0;">
      <!-- <p style="height:20px;width:100%;text-align: center;color: #999;font-size:12px;">关于我们| 隐私政策</p> -->
      <p style="height:20px;width:100%;text-align: center;color: #999;font-size:12px;">
        <a href="#" target="_blank" style="color: #999;text-decoration:none;">关于我们</a><span
          style="color: #999;">|</span>
        <a href="#" target="_blank" style="color: #999;text-decoration:none;">隐私政策</a>
      </p>
      <div
        style="height:20px;width:100%;text-align: center;color: #999;font-size:12px;display:flex;align-items: center;">
        <div style="margin-left:30%;">太仓聚一堂网络科技有限公司| </div>
        <div><img style="width:20px;height:20px;" src="https://oss.ansongqiubo.com/Image/beian/2.png" alt=""></div>
        <div>苏公网安备 32058502010105号|<a href="https://beian.miit.gov.cn" target="_blank"
            style="color:#999;text-decoration:none;"> 苏ICP备17043616号|</a> </div>
        <div><img style="width:20px;height:20px;" src="https://oss.ansongqiubo.com/Image/beian/3.png" alt=""></div>
        <div>苏网文〔2017〕9070-170号</div>
      </div>
      <div
        style="height:20px;width:100%;text-align: center;color: #999;font-size:12px;display:flex;align-items: center;">
        <div style="margin-left:37%;"><img style="width:20px;height:20px;"
            src="https://oss.ansongqiubo.com/Image/beian/1.png" alt=""></div>
        <div>中国互联网举报中心| 网络违法举报网站| 12318 全国文化市场举报网站</div>
      </div>
    </div>
    <div v-show="tishi"
      style="position: absolute;top: calc(50% - 142px/2);left: calc(50% - 248px/2);text-align: center;height: 142px;border-radius: 6px;background-color: rgba(255, 255, 255, 1);width: 248px;">
      <img style="margin-top:30px;" src="https://oss.ansongqiubo.com/assets/personimage/tijiao.png" alt="">
      <div style="margin-top:20px;">绑定成功</div>
    </div>
    <div v-show="tishi1"
      style="position: absolute;top: calc(50% - 142px/2);left: calc(50% - 248px/2);text-align: center;height: 142px;border-radius: 6px;background-color: rgba(255, 255, 255, 1);width: 248px;">
      <img style="margin-top:30px;" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="">
      <div style="margin-top:20px;">绑定失败</div>
    </div>
  </div>
</template>
<script>
import aliplayer from '../components/aaaaaa.vue'
import Nav from '../component/Nav.vue'
import qs from 'qs'
export default {
  inject: ['reload'],
  data() {
    return {
      zhanghao: false,
      tongyi: false,
      mobile: "",
      token: "",
      code: "",
      botton2: false,
      botton1: true,
      btnTitle: "60s",
      tishi: false,
      tishi1: false,
      hint: ''
    }
  },
  created(){
    if (this.$route.query.from == 'v2') {
      // console.log('=====1',this.$route.query.callbackUrl);
      // console.log('=====2',this.$route.hash);
      let url = 'https://www.longzhulive.com/thirdTrans.html?callbackUrl=' + this.$route.query.callbackUrl + '&'+  this.$route.hash.replace('#','');
      // console.log('url',url)
      location.href = url
      return
    }
  },
  mounted() {
    // https://www.longzhulive.com/binduser?from=v2&callbackUrl=aHR0cDovLzE5Mi4xNjguMC4xMTk6ODA4MC8jL215L2Jhc2U%3D#access_token=7050FA3A97AD3427901AAA730E7F0B29&expires_in=7776000
    // if(location.href.search('from=v2')){
    //   location.href = 'https://www.longzhulive.com/thirdTrans.html?callbackUrl='+ this.$route.query.callbackUrl + '&_='
    // }
    // return
    //  如果是来自新龙珠V2的来源，则中转出去到/thirdTrans.html
    if (this.$route.query.from == 'v2') {
      return
    }
    var url = document.location.hash;
    var params = url.split("#")[1].split("&")
    var obj = {}
    params.map(item => obj[item.split("=")[0]] = item.split("=")[1])
    this.code = obj.access_token
    console.log(obj)
    this.$axios({
      transformRequest: [function (data) {      //在请求之前对data传参进行格式转换
        data = qs.stringify(data)
        return data
      }],
      url: this.api + '/v1/third/login',
      method: 'post',
      data: {
        code: obj.access_token,
        thirdName: "qq"
      }
    }).then(res => {
      // console.log(res);
      if (res.data.message == "success") {
        localStorage.setItem('token', res.data.data.lzid)
        this.$refs.nava.userData2()
        this.$router.push('/')
      }
    })
  },
  methods: {
    acquiretoken() {
      const reg = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/;
      if (this.mobile == '' || this.mobile.length <= 10 || !reg.test(this.mobile)) {
        this.hint = '手机号码错误'
      } else {
        this.hint = ''
        this.botton1 = false;
        this.botton2 = true;
        let time = 60;
        let timer = setInterval(() => {
          if (time == 0) {
            clearInterval(timer);
            this.botton1 = true;
            this.botton2 = false;
            this.btnTitle = "60s"
          } else {
            this.btnTitle = time + "s";
            time--;
          }
        }, 1000)
      }
      this.$axios({
        transformRequest: [function (data) {      //在请求之前对data传参进行格式转换
          data = qs.stringify(data)
          return data
        }],
        url: this.api + '/v1/third/bindThirdSmsCode',
        method: 'post',
        data: {
          mobile: this.mobile
        }
      }).then(res => {
        // console.log(res);
      })
    },
    Login() {
      this.$axios({
        transformRequest: [function (data) {      //在请求之前对data传参进行格式转换
          data = qs.stringify(data)
          return data
        }],
        url: this.api + '/v1/third/bindUser',
        method: 'post',
        data: {
          code: this.code,
          mobile: this.mobile,
          token: this.token,
          thirdName: "qq"
        }
      }).then(res => {
        console.log(res);
        if (res.data.message == "success") {
          localStorage.setItem('token', res.data.data.lzid)
          this.$refs.nava.userData2()
          this.tishi = true
          setTimeout(() => {
            this.tishi = false
            this.$router.push('/')
          }, 2000)
        } else {
          this.tishi1 = true
          setTimeout(() => {
            this.tishi1 = false
          }, 2000)
        }
      })
    },
  },
  components: {
    Nav,
    "ali-player": aliplayer
  },
}
</script>

<style scoped>
.home-longin-botton3 {
  border-radius: 4px;
  border: 0px;
  outline: none;
  width: 304px;
  height: 40px;
  background: #D4B2FF;
  text-align: center;
  line-height: 40px;
  margin-top: 25px;
  color: #fff;
  cursor: pointer;
}

.home-longin-div6 {
  width: 304px;
  height: 53px;
  margin-top: 43px;
  justify-content: space-between;
  color: #B3B3B3;
  font-size: 12px;
}

.home-longin-div6>a {
  text-decoration: none;
  color: white;
}
</style>
<style>
.denglubutton {
  background-color: rgba(114, 30, 220, 1) !important;
}
</style>



// WEBPACK FOOTER //
// src/component/binduser.vue